<lib-ph-bhp-dashboard [isDesktop]="true" [userData]="config.userData" (childData)="onChildData($event)"></lib-ph-bhp-dashboard>